<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import Swal from "sweetalert2";
import moment from "moment";
import axios from "axios";
import DataTable from "@/components/DataTable.vue";

export default {
  page: {
    title: "Sales",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
    DataTable,
  },

  data() {
    return {
      filterTitle: "Held Sales Report",
      title: "Held Sales Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Held Sales Report",
          active: true,
        },
      ],
      totalRows: 1,
      data: {
        datefrom: "",
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        product: "",
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      pageOptions: [10, 25, 50, 100, 200, 1000],
      serverPerPage: 50,
      AllSaleHeldServerPaginated: true,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      filteredReport: [],
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        { key: "name", label: "NAME", sortable: false },
        { key: "qty", label: "QUANTITY", sortable: false },
        { key: "price", label: "UNIT PRICE", sortable: false },
        { key: "total_price", label: "TOTAL PRICE", sortable: false },
        {
          key: "dateAdded",
          sortable: true,
          label: "DATE",
        },
        {
          key: "identification",
          sortable: true,
          label: "IDENTIFICATION",
        },
        {
          key: "user",
          sortable: true,
          label: "USER",
        },
      ],
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("saledetails", ["Sales"]),
    ...mapGetters("sales", [
      "filterStatus",
      "AllSaleHeld",
      "Products",
      "AllSaleHeldPagination",
      "AllSaleHeldPaginated",
    ]),

    rows() {
      return this.AllSaleHeldServerPaginated
        ? this.AllSaleHeldPagination.total
        : this.AllSaleHeld
        ? this.AllSaleHeld.length
        : 0;
    },

    perPage: {
      get() {
        if (this.AllSaleHeldServerPaginated) {
          return (
            this.AllSaleHeldPagination.per_page ||
            this.data.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.AllSaleHeldServerPaginated) {
          this.data.per_page = value;
          this.data.page = 1;
          this.FetchSalesHeld(this.data);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.AllSaleHeldPaginated && this.AllSaleHeldPagination
          ? this.AllSaleHeldPagination.current_page
          : 1;
      },
      set(value) {
        if (this.AllSaleHeldPaginated) {
          this.data.page = value;
          this.handlePageChange(value);
        }
      },
    },
  },

  watch: {
    AllSaleHeld(newValue) {
      if (newValue) {
        this.FetchfilteredData();
      }
    },
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },

  methods: {
    ...mapActions({
      FetchSalesHeld: "sales/fetchAllHeld",
      FetchProducts: "sales/fetchItems",
    }),

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    FetchfilteredData() {
      this.filteredReport = this.AllSaleHeld;
    },

    filterReport() {
      let payload = { ...this.data };

      payload.page = 1;
      // Keep the current per_page value instead of resetting to serverPerPage
      if (!payload.per_page) {
        payload.per_page = this.serverPerPage;
      }

      this.FetchSalesHeld(payload);
    },

    Excel_export() {
      axios
        .post("export_heldsales", this.data, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "heldsales_report.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          // this.$toast.add({
          //   severity: "success",
          //   summary: "Successful",
          //   detail: "Sales Report Downloaded successfully",
          //   life: 6000,
          // });
          this.spinner = false;
        })
        .catch(() => {
          // this.spinner = false;
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Something wrong",
          //   detail: "Sales Report Download failed",
          //   life: 6000,
          // });
        });
    },

    handlePageChange(newPage) {
      if (this.AllSaleHeldServerPaginated) {
        this.data.page = newPage;
        this.FetchSalesHeld(this.data);
      }
    },
  },

  created() {
    this.FetchSalesHeld();
    this.FetchProducts();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div v-if="filterTitle" class="col-12">
                <h4>
                  <center>{{ filterTitle }}</center>
                </h4>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-2 mt-4">
                <b-button variant="info" @click="Excel_export()"
                  ><i class="fa fa-download"></i>Export</b-button
                >
              </div>
              <div class="col-md-2 form-group">
                <label>From</label>
                <input
                  type="date"
                  v-model="data.datefrom"
                  class="form-control"
                  v-limit-future-date
                />
              </div>
              <div class="col-md-2 form-group">
                <label>To</label>
                <input type="date" v-model="data.dateto" class="form-control" v-limit-future-date/>
              </div>
              <div class="col-md-4 form-group">
                <label>Search Product</label>
                <b-form-input
                  v-model="data.product"
                  type="search"
                  placeholder="Search by product name"
                  class="form-control"
                ></b-form-input>
              </div>
              <div class="col-md-2 mt-4">
                <button
                  class="btn btn-primary"
                  type="button"
                  @click="filterReport()"
                >
                  <span class="fa fa-search"></span> Search
                  <b-spinner
                    v-show="filterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <DataTable
                :columns="fields"
                :rows="AllSaleHeld"
                :total-rows="rows"
                :pagination="AllSaleHeldPagination"
                :server-pagination="AllSaleHeldServerPaginated"
                :loading="filterStatus"
              >
                <template #cell(index)="{ index }">
                  {{ (currentPage - 1) * perPage + index + 1 }}
                </template>
                <template #cell(name)="{ row }">
                  <div v-for="(det, idx) in row.items" :key="idx" class="mb-4">
                    <div>{{ det.name }}</div>
                  </div>
                </template>

                <template #cell(qty)="{ row }">
                  <div v-for="(det, idx) in row.items" :key="idx" class="mb-4">
                    {{ det.quantity }}{{ det.unit }}
                  </div>
                </template>

                <template #cell(price)="{ row }">
                  <div v-for="(det, idx) in row.items" :key="idx" class="mb-4">
                    {{ det.selling ? thousandSeperator(det.selling) : 0 }}
                  </div>
                </template>

                <template #cell(total_price)="{ row }">
                  <div v-for="(det, idx) in row.items" :key="idx" class="mb-4">
                    {{
                      det.selling
                        ? thousandSeperator(det.selling * det.quantity)
                        : 0
                    }}
                  </div>
                </template>
              </DataTable>
            </div>

            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
